import { type ExperienceActivationContext, type ExperienceActivationInstance } from 'sd-types/app/experience/activation'
import { type EmbedHooks } from '.'
import { type EmbedElementContext } from '../element-embedder'

export class ExperienceHooks implements EmbedHooks {
  async onAfterCreateElement (context: EmbedElementContext): Promise<void> {
    applyPlayPauseBehavior(context)
  }
}

function applyPlayPauseBehavior (context: EmbedElementContext) {
  let wasPaused = false

  // when playing, we need to capture that it was no longer paused
  context.embedTarget?.mediaControl?.on('play', () => {
    wasPaused = false
  })

  // wire up play/pause handling on activation
  context.eventEmitter.on('activation', (e: { event: string, activation: ExperienceActivationInstance, context: ExperienceActivationContext }) => {
    // if the video was already paused, then we shouldn't interfere with that
    if (wasPaused) {
      return
    }

    // TODO: once full activation and distribution contexts are available,
    // we need to check the playThroughDetails behavior
    if (e.event === 'clicked') {
      // capture the current state of paused
      wasPaused = context.embedTarget?.mediaControl?.paused === true

      if (e.activation.settings?.behavior?.playThroughDetails !== true) {
        context.embedTarget?.mediaControl?.pause()
      }
    } else if (e.event === 'closed') {
      context.embedTarget?.mediaControl?.play()
    }
  })
}
